export default __webpack_public_path__ + "static/media/card-img-3.01ed6766.png";